/* eslint-disable  react/prop-types */

import React from 'react';

const MoneyBackIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1543_93072)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0953 14.6737L17.4981 6.96129V6.9318H14.2723C14.1225 6.9318 14 6.79908 14 6.65161V5.28018C14 5.13272 14.1225 5 14.2723 5H20.2203C20.3564 5 20.4517 5.08848 20.4517 5.2212V5.28018C20.4517 5.35392 20.4517 5.38341 20.3972 5.51613L16.2595 14.8802C16.0961 15.2636 15.892 15.3226 15.6878 15.3226H14.2995C14.1362 15.3226 14.0137 15.2046 14.0137 15.0276C14.0137 14.8802 14.0409 14.7917 14.0953 14.6737ZM7.677 16C7.57746 16 7.50005 16.0902 7.50005 16.1916V22.8084C7.50005 22.9098 7.57746 23 7.677 23H10.0659C11.9517 23 13.5 21.4275 13.5 19.4887C13.5 17.5725 11.9572 16 10.0659 16H7.677ZM11.8742 19.4944C11.8742 20.6328 11.1609 21.5233 10.0549 21.5233V21.529H9.02631V17.4767H10.0549C11.1609 17.4767 11.8742 18.3615 11.8742 19.4944ZM16.7713 16.111L13.5214 22.7391C13.4569 22.8723 13.5449 23 13.6974 23H14.8413C15.0525 23 15.164 22.8779 15.2167 22.7613L15.5922 21.973H18.4138L18.7892 22.7502C18.8831 22.9334 18.9652 22.9944 19.1529 22.9944H20.3027C20.4552 22.9944 20.5432 22.8668 20.4787 22.7391L17.2288 16.111C17.1995 16.05 17.1232 16 17.0528 16H16.9473C16.8769 16 16.8006 16.05 16.7713 16.111ZM17.0059 19.0087L17.792 20.6352H16.214L16.9942 19.0087H17.0059ZM21.7131 19.6296L19.5307 16.2874C19.4526 16.1578 19.5307 16 19.687 16H20.9707C21.0489 16 21.0991 16.0507 21.127 16.0902L22.5 18.1417L23.8731 16.0902C23.901 16.0507 23.9401 16 24.0294 16H25.3131C25.4694 16 25.5475 16.1578 25.4694 16.2874L23.2535 19.6184V22.8084C23.2535 22.9098 23.1642 23 23.0638 23H21.8861C21.78 23 21.6963 22.9098 21.6963 22.8084V19.6296H21.7131Z"
        fill="#00AED9"
      />
      <path
        d="M15.9975 1C19.3269 1 28.6251 3.525 28.6251 3.525L29 3.625V19.705C29 21.23 28.4052 22.745 27.2404 24.2C26.3206 25.35 25.0308 26.475 23.4111 27.545C22.2213 28.325 20.8766 29.07 19.4069 29.75C18.2521 30.285 17.3773 30.615 17.0523 30.735L15.9975 31L14.9477 30.735C14.6278 30.62 13.748 30.285 12.5932 29.75C11.1235 29.07 9.77874 28.33 8.58897 27.545C6.96928 26.475 5.67953 25.35 4.75971 24.2C3.58993 22.74 3.00005 21.23 3.00005 19.705V3.625L3.36997 3.525C3.7449 3.42 12.6682 1 15.9975 1Z"
        stroke="#00619E"
        strokeWidth="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_1543_93072">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MoneyBackIcon;
